import { LeaderboardRounded, WaterfallChartRounded, StackedLineChartRounded, PercentRounded } from "@mui/icons-material";
import ProgressStat from "../../../components/ProgressStat";
import { Row, Col } from "antd";
import React from "react";

const PortfolioStats = ({ portfolioStats }) => {
  const totalWeight = portfolioStats?.totalWeight ?? 0;
  console.log(portfolioStats)
  return (
    <Row gutter={[16, 16]} align="middle">
      <Col xs={24} sm={12} md={6} lg={6}>
        <ProgressStat
          title={"Percent Filled"}
          value={totalWeight.toFixed(3)}
          icon={<PercentRounded fontSize={"small"} />}
          suffix={"%"}
          color={totalWeight < 100 ? "var(--red)" : "var(--green)"}
          colorText={totalWeight < 100 ? "var(--red)" : "#000"}
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={6}>
        <ProgressStat
          title={"3 Month Vol"}
          value={portfolioStats.threeMonthVol}
          icon={<LeaderboardRounded fontSize={"small"} />}
          suffix={"%"}
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={6}>
        <ProgressStat
          title={"Beta (S&P 500)"}
          value={portfolioStats.oneYearBetaSpy}
          icon={<WaterfallChartRounded fontSize={"small"} />}
          suffix={"%"}
        />
      </Col>
      <Col xs={24} sm={12} md={6} lg={6}>
        <ProgressStat
          title={"Corr (S&P 500)"}
          value={portfolioStats.oneYearCorrSpy}
          icon={<StackedLineChartRounded fontSize={"small"} />}
          suffix={"%"}
        />
      </Col>
    </Row>
  );
};

export default PortfolioStats;
